import { render, staticRenderFns } from "./WoltArticleOptionsForm.vue?vue&type=template&id=c1851718"
import script from "./WoltArticleOptionsForm.vue?vue&type=script&lang=ts"
export * from "./WoltArticleOptionsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports